/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTicketRequest} from '@cash-web/protos/squareup/client/flipper/flipper.pb'
import {GetTicketResponse} from '@cash-web/protos/squareup/client/flipper/flipper.pb'


export const getTicket = (request: GetTicketRequest, options?: CashRequestOptions) => post<GetTicketRequest, GetTicketResponse>("/2.0/cash/get-ticket", request, {...options, rejectOnError: true })